import React from 'react';
import {
    Filter,
    List,
    Edit,
    Create,
    Show,
    SimpleShowLayout,
    Datagrid,
    TextField,
    DateField,
    SimpleForm,
    TextInput,
    DisabledInput,
    SelectInput,
    ReferenceInput,
    EditButton,
    DeleteButton,
    ShowButton,
    ReferenceField
} from 'react-admin';

const SiteFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Client" source="Client" reference="Client" linkType="show" allowEmpty>
            <SelectInput optionText="Name" />
        </ReferenceInput>
    </Filter>
);

export const SiteList = (props) => (
    <List title="Sites" {...props} filters={<SiteFilter />} sort={{ field: 'Name', order: 'ASC' }} >
        <Datagrid>
            <TextField source="Name" />
			<ReferenceField label="Client" source="Client" reference="Client" linkType="show">
                <TextField source="Name" />
			</ReferenceField>
			<TextField label="Suburb" source="Address.Suburb" />
			<TextField label="State" source="Address.State" />
			<TextField label="Country" source="Address.Country" />
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

const SiteTitle = ({ record }) => {
	return <span>{record ? `"${record.Name ? record.Name : ''}"` : ''}</span>;
};

export const SiteShow = (props) => (
    <Show title={<SiteTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Name" />
            <ReferenceField label="Client" source="Client" reference="Client" linkType="show">
                <TextField source="Name" />
			</ReferenceField>
			<TextField label="Address Line 1" source="Address.Address_Line_1" />
			<TextField label="Address Line 2" source="Address.Address_Line_2" />
			<TextField label="Suburb" source="Address.Suburb" />
			<TextField label="State" source="Address.State" />
			<TextField label="PostCode" source="Address.PostCode" />
			<TextField label="Country" source="Address.Country" />
        </SimpleShowLayout>
    </Show>
);

const required = (message = 'Required') =>
    value => value ? undefined : message;
const validateReq = [required()];

export const SiteEdit = (props) => (
    <Edit title={<SiteTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="Name" validate={validateReq} required />
            <ReferenceInput label="Client" source="Client" reference="Client">
                <SelectInput optionText="Name" />
			</ReferenceInput>
			<TextInput label="Address Line 1" source="Address.Address_Line_1" />
			<TextInput label="Address Line 2" source="Address.Address_Line_2" />
			<TextInput label="Suburb" source="Address.Suburb" />
			<TextInput label="State" source="Address.State" />
			<TextInput label="PostCode" source="Address.PostCode" />
			<TextInput label="Country" source="Address.Country" />
        </SimpleForm>
    </Edit>
);

export const SiteCreate = (props) => (
    <Create title="Create Site" {...props}>
        <SimpleForm>
            <TextInput source="Name" validate={validateReq} required />
            <ReferenceInput label="Client" source="Client" reference="Client">
                <SelectInput optionText="Name" />
			</ReferenceInput>
			<TextInput label="Address Line 1" source="Address.Address_Line_1" />
			<TextInput label="Address Line 2" source="Address.Address_Line_2" />
			<TextInput label="Suburb" source="Address.Suburb" />
			<TextInput label="State" source="Address.State" />
			<TextInput label="PostCode" source="Address.PostCode" />
			<TextInput label="Country" source="Address.Country" />
        </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/resources/sites.js